<mat-stepper #stepper [linear]="true" class="register">
    @if (community?.questions?.length || domains?.length) {
        <mat-step>
            <ng-template matStepLabel>
                <div [innerHTML]=" community?.eligibility_survey_title_rendered || 'Eligibility'"></div>
            </ng-template>
            <app-onboarding-questions #appOnboardingQuestionsComponent
                                      (onSuccessEligibilityCheck)="checkEligibility()"
                                      (storeEligibilityAnswers)="setAnswers($event)"
                                      (userProfilingRequired)="setUserRequiresProfiling($event)"
                                      (setUserEligibilityEmail)="setUserEmail($event)"
                                      [community]="community"
                                      [domains]="domains"
                                      [email]="this.email"
                                      [showHeader]="false"/>
        </mat-step>
    }
    @if (community?.profile_questions_count && community?.profile_questions_count > 0 && userRequiresProfiling) {
        <mat-step>
            <ng-template matStepLabel>
                <div [innerHTML]="community?.profile_survey_title_rendered  || 'Profile'"></div>
            </ng-template>
            <app-profile-questions [card]="false"
                                   (storeProfileAnswers)="setProfileAnswers($event)"
                                   [isRegistrationPage]="true"
                                   [redirect]="false"
                                   [community]="community"
                                   [showHeader]="false"/>
        </mat-step>
    }
    <mat-step>
        <ng-template matStepLabel>
            <div [innerHTML]="community?.registration_form_title_rendered || 'Register'"></div>
        </ng-template>
        @if (!needLogin) {
            <!--      <p>If you already have an explain account please login to complete your registration
            <button mat-raised-button color="accent" (click)="login = true">Login</button>
          </p>-->
            @if (!this.community?.register_intro_text_rendered) {
                <p>
                    Welcome to the {{ companyName }} online community, please create an account to get involved.
                    This information will be stored by Explain Market Research, the organisation who help us manage this
                    community. You can read more about how we use your data in our
                    <a [routerLink]="['/privacy-policy']" target="_blank">Privacy Policy</a>.
                </p>
            }
            @if (this.community?.register_intro_text_rendered) {
                <div [innerHTML]="community?.register_intro_text_rendered"
                     class="ck-editorControl"></div>
            }
            <form [formGroup]="signUpForm" class="mt-10">
                <div [class.rowTwo]="!this.community?.hide_post_code">
                    <div [class.column-reverse]="this.community?.register_username_help_text_below_input"
                         [class.gap-5]="this.community?.register_username_help_text_below_input"
                         class="d-flex flex-col">
                        <div [innerHTML]="community?.username_help_text_rendered? community?.username_help_text_rendered: '<p>Create a username to create your community profile, but don\'t use your real name or email address as this will be visible to community members. Your username can only contain alphanumeric characters, including (-_8.) and no spaces.</p>'"
                             class="muted ck-editorControl"
                             [class.mb-30]="this.community?.register_username_help_text_below_input"
                             [class.noMarginP]="this.community?.register_username_help_text_below_input">
                        </div>
                        <mat-form-field appearance="outline" class="w-100" color="accent">
                            <mat-label>Username</mat-label>
                            <input formControlName="username" matInput autocomplete="off">
                            @if (usernameTaken) {
                                <mat-hint class="errorMsg">
                                    That username is already taken
                                </mat-hint>
                            } @else if (signUpForm.controls['username'].hasError('required')) {
                                <mat-error>
                                    This field is required
                                </mat-error>
                            } @else if (signUpForm.controls['username'].hasError('pattern')) {
                                <mat-error>
                                    Your username can only contain alphanumeric characters, including (-_8.) and no
                                    spaces.
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div [class.column-reverse]="this.community?.register_post_code_help_text_below_input"
                         [class.gap-5]="this.community?.register_post_code_help_text_below_input">
                        @if (!this.community?.hide_post_code) {
                            <div [innerHTML]="community?.post_code_help_text_rendered? community?.post_code_help_text_rendered: '<p>We use this information to understand the geographic spread of our members, this will not be visible to community members</p>'"
                                 class="muted ck-editorControl"
                                 [class.mb-30]="this.community?.register_post_code_help_text_below_input"
                                 [class.noMarginP]="this.community?.register_post_code_help_text_below_input">
                            </div>
                            <mat-form-field appearance="outline" class="w-100" color="accent">
                                <mat-label>{{ community?.postcode_placeholder_text ? community?.postcode_placeholder_text : 'Your postcode e.g. NE1' }}</mat-label>
                                <input formControlName="postcode" matInput maxlength="4" minlength="2">
                                @if (signUpForm.controls['postcode'].hasError('required')) {
                                    <mat-error>
                                        This field is required
                                    </mat-error>
                                }
                                @if (signUpForm.controls['postcode'].hasError('pattern') && !signUpForm.controls['postcode'].hasError('minlength') && !signUpForm.controls['postcode'].hasError('maxlength')) {
                                    <mat-error>
                                        Please enter a valid first half of a postcode
                                    </mat-error>
                                }
                                @if (signUpForm.controls['postcode'].hasError('maxlength')) {
                                    <mat-error>
                                        First half of a postcode should be no more than 4 characters
                                    </mat-error>
                                }
                                @if (signUpForm.controls['postcode'].hasError('minlength')) {
                                    <mat-error>
                                        First half of a postcode should be no less than 2 characters
                                    </mat-error>
                                }
                            </mat-form-field>
                        }
                    </div>
                </div>
                <div [class.column]="community?.stacked_confirmation_dialogs" class="rowTwo"
                     [class.gap-5]="this.community?.stacked_confirmation_dialogs">
                    <div [class.column-reverse]="this.community?.register_email_help_text_below_input">
                        @if (!community?.stacked_confirmation_dialogs) {
                            <div [class.mb-30]="this.community?.register_email_help_text_below_input"
                                 [innerHTML]="community?.email_help_text_rendered? community?.email_help_text_rendered: '<p>We need your email address to create your account and so that the community manager can send you transactional emails, this will not be visible to community members. These emails will contain information relevant to the community. such as updates and reminders on new community content, member interactions and prize draw announcements</p>'"
                                 class="muted ck-editorControl">
                            </div>
                        }
                        <mat-form-field [class.disabled]="!!invite || !!this.email" appearance="outline" class="w-100"
                                        color="accent">
                            <mat-label>Email address</mat-label>
                            <input #emailInput [readonly]="!!invite || !!this.email"
                                   class="form-control"
                                   formControlName="email" matInput autocomplete="off"
                                   matInput type="email"/>
                            @if (signUpForm.controls['email'].hasError('required')) {
                                <mat-error>
                                    This field is required
                                </mat-error>
                            }
                            @if (signUpForm.controls['email'].hasError('email')) {
                                <mat-error>
                                    Please enter a valid email address
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div [classList]="this.community?.register_email_help_text_below_input? 'justify-content-start':'justify-content-end'">
                        <mat-form-field [class.disabled]="!!invite || !!this.email" appearance="outline" class="w-100"
                                        color="accent">
                            <mat-label>Confirm email address</mat-label>
                            <input #confirmEmailInput [readonly]="!!invite || !!this.email"
                                   class="form-control"
                                   formControlName="confirmEmail" matInput autocomplete="off"
                                   type="email"/>
                            @if (signUpForm.controls['confirmEmail'].hasError('required')) {
                                <mat-error>
                                    This field is required
                                </mat-error>
                            }
                            @if (signUpForm.controls['confirmEmail'].hasError('email')) {
                                <mat-error>
                                    Please enter a valid email address
                                </mat-error>
                            }
                            @if (signUpForm.get('confirmEmail')?.dirty && emailInput.value !== confirmEmailInput.value) {
                                <mat-hint class="errorMsg">
                                    Email does not match
                                </mat-hint>
                            }
                        </mat-form-field>
                    </div>
                    @if (community?.stacked_confirmation_dialogs && this.community?.register_email_help_text_below_input) {
                        <div [innerHTML]="community?.email_help_text_rendered? community?.email_help_text_rendered: '<p>We need your email address to create your account and so that the community manager can send you transactional emails, this will not be visible to community members. These emails will contain information relevant to the community. such as updates and reminders on new community content, member interactions and prize draw announcements</p>'"
                             class="muted ck-editorControl mb-30 noMarginP">
                        </div>
                    }
                </div>
                @if (community?.password_help_text_rendered && !this.community?.register_password_help_text_below_input) {
                    <div [innerHTML]="community?.password_help_text_rendered"
                         class="muted ck-editorControl">
                    </div>
                }
                <div [class.column]="community?.stacked_confirmation_dialogs" class="rowTwo"
                     [class.gap-5]="this.community?.stacked_confirmation_dialogs">
                    <div [class.d-none]="!!this.email">
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Password</mat-label>
                            <input #password formControlName="password" [readonly]="!!this.email"
                                   matInput maxlength="32" minlength="8"
                                   type="password" autocomplete="new-password">
                            @if (signUpForm.controls['password'].hasError('required')) {
                                <mat-error (click)="password.focus()">
                                    This field is required
                                </mat-error>
                            }
                            @if (signUpForm.controls['password'].hasError('minlength')) {
                                <mat-error (click)="password.focus()"
                                           [style.color]="community?.password_minimum_character_alert_colour_hex">
                                    Password must be at least 8 characters long
                                </mat-error>
                            }
                            @if (signUpForm.controls['password'].hasError('maxlength')) {
                                <mat-error (click)="password.focus()">
                                    Password must be at less than 32 characters long
                                </mat-error>
                            }
                        </mat-form-field>
                        @if (community?.password_help_text_rendered && this.community?.register_password_help_text_below_input && !community?.stacked_confirmation_dialogs) {
                            <div [innerHTML]="community?.password_help_text_rendered"
                                 class="muted ck-editorControl" [class.d-none]="!!this.email">
                            </div>
                        }
                    </div>
                    <div [class.d-none]="!!this.email">
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Confirm password</mat-label>
                            <input #confirmPassword formControlName="confirmPassword"
                                   matInput type="password" autocomplete="new-password" [readonly]="!!this.email">
                            @if (signUpForm.controls['confirmPassword'].hasError('required')) {
                                <mat-error (click)="confirmPassword.focus()">
                                    This field is required
                                </mat-error>
                            }
                            @if (confirmPassword.value && password.value && password.value != confirmPassword.value) {
                                <mat-hint (click)="confirmPassword.focus()"
                                          class="errorMsg">
                                    Fields must match
                                </mat-hint>
                            }
                        </mat-form-field>
                    </div>
                    @if (community?.password_help_text_rendered && this.community?.register_password_help_text_below_input && community?.stacked_confirmation_dialogs) {
                        <div [innerHTML]="community?.password_help_text_rendered"
                             class="muted ck-editorControl" [class.d-none]="!!this.email">
                        </div>
                    }
                    <div>
                        <p>{{ community?.profile_picture_title_text ? community?.profile_picture_title_text : 'Profile picture' }}</p>
                        <div class="text-center justify-content-center">
                            @if (showCropper) {
                                <div style="width: 250px;margin:auto">
                                    <image-cropper
                                            (imageCropped)="imageCropped($event)"
                                            [aspectRatio]="1"
                                            [imageChangedEvent]="imageChangedEvent"
                                            [maintainAspectRatio]="true"
                                            [resizeToWidth]="250"
                                            [roundCropper]="true"
                                            format="png"
                                    ></image-cropper>
                                </div>
                            }
                            @if (!image) {
                                <div (click)="fileInput.click()"
                                     [style.background-color]="community?.upload_profile_picture_background_color_hex"
                                     [style.color]="this.themeService.getReadableColor(community?.upload_profile_picture_background_color_hex)"
                                     aria-label="Update Profile Picture"
                                     class="initial justify-content-center" matTooltip="Update profile picture"
                                     role="button">
                                    <span>{{ community?.profile_picture_inner_text ? community?.profile_picture_inner_text : 'Select Photo' }}</span>
                                </div>
                            }
                            @if (image) {
                                <img (click)="fileInput.click()" [src]="image" alt=""
                                     aria-label="Update Profile Picture"
                                     class="pp" matTooltip="Update profile picture">
                            }
                            <input #fileInput (change)="onFileInput($event)" [multiple]="false"
                                   accept=".jpg, .jpeg, .png, .bmp, .svg, .webp" class="d-none"
                                   type="file"/>
                        </div>
                        @if (community?.profile_picture_help_text_rendered) {
                            <div [innerHTML]="community?.profile_picture_help_text_rendered">
                            </div>
                        }
                        @if (!community?.profile_picture_help_text_rendered) {
                            <div>
                                <p>Click to update profile picture</p>
                            </div>
                        }
                        @if (community?.profile_picture_guidance_text_rendered) {
                            <div [innerHTML]="community?.profile_picture_guidance_text_rendered"
                                 class="profileHelp">
                            </div>
                        }
                        @if (!community?.profile_picture_guidance_text_rendered) {
                            <div class="profileHelp">
                                <small>Max file size: {{ this.maxFileSize }}MB</small>
                                <small>Minimum size: 100 x 100</small>
                                <small>Allowed formats: JPG, JPEG, PNG, BMP, SVG, WEBP</small>
                                <small>Please note your profile picture will be visible to other community
                                    members.</small>
                            </div>
                        }
                    </div>
                    <div class="flex-auto">
                        <mat-form-field appearance="outline" class="w-100 h-100 fullHeightChildren"
                                        color="accent">
                              <textarea
                                      [placeholder]="community?.bio_placeholder_text? community?.bio_placeholder_text : 'Bio'"
                                      formControlName="bio"
                                      matInput maxlength="400"
                                      name="message"
                                      rows="1"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="flex-space-between">
                        <div [innerHTML]="community?.terms_help_text_rendered? community?.terms_help_text_rendered: '<p>By creating an account on the ' + companyName +' community, you are giving consent to receiving transactional emails from the Community. The receipt of these emails is important to help you keep up to date on the Community and its content. For more information please refer to our Terms and Conditions and Privacy Policy below.</p>'"
                             class="muted ck-editorControl">
                        </div>
                        <mat-checkbox class="mb-3 w-100" color="accent" formControlName="termsConsent">
                            <small>I have read and understand the
                                <a [routerLink]="['/terms-and-conditions']" target="_blank">Terms and conditions</a>
                                regarding the sign up.</small>
                        </mat-checkbox>
                    </div>
                    <div class="flex-space-between">
                        <div [innerHTML]="community?.email_alerts_text_rendered? community?.email_alerts_text_rendered: '<p>If you do not wish to receive emails alerts from the Community please do not join the ' +  companyName + ' community </p>'"
                             class="muted ck-editorControl">
                        </div>
                        <mat-checkbox class="mb-3 w-100" color="accent" formControlName="privacyConsent">
                            <small>I have read and understand the
                                <a [routerLink]="['/privacy-policy']" target="_blank">Privacy Policy</a>
                                regarding the sign up.</small>
                        </mat-checkbox>
                    </div>
                </div>
            </form>
            <div class="w-100 text-center" (mouseenter)="validateForm(signUpForm)">
                <button (click)="create()"
                        [disabled]="loading || signUpForm.invalid || !this.signUpForm.value?.termsConsent|| !this.signUpForm.value?.privacyConsent|| emailInput.value !== confirmEmailInput.value || ((password.value != confirmPassword.value && !this.email)) || this.usernameTaken"
                        class="mx-auto"
                        color="accent" mat-flat-button>
                    Submit
                    @if (loading) {
                        <mat-icon>
                            <mat-spinner color="accent"></mat-spinner>
                        </mat-icon>
                    }
                </button>
            </div>
        }
        @if (needLogin) {
            @if (loginPrompt) {
                <p>{{ loginPrompt }}</p>
            }
            @if (community?.already_have_an_account_text_rendered) {
                <div [innerHTML]="community?.already_have_an_account_text_rendered"></div>
            }
            @if (community?.subtext_for_email_on_already_have_an_account) {
                <div [innerHTML]="community?.subtext_for_email_on_already_have_an_account"
                     class="muted ck-editorControl mb-5">
                </div>
            }
            @if (view == 'Login') {
                <form [formGroup]="loginForm" class="mt-10">
                    <mat-form-field appearance="outline" class="w-100" color="accent">
                        <mat-label>Email address</mat-label>
                        <input appAutofill formControlName="email" matInput type="email"/>
                        @if (loginForm.controls['email'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                        @if (loginForm.controls['email'].hasError('email')) {
                            <mat-error>
                                Please enter a valid email address
                            </mat-error>
                        }
                    </mat-form-field>
                    @if (community?.subtext_for_password_on_already_have_an_account) {
                        <div [innerHTML]="community?.subtext_for_password_on_already_have_an_account"
                             class="muted ck-editorControl mb-5">
                        </div>
                    }
                    <mat-form-field appearance="outline" class="w-100" color="accent">
                        <mat-label>Password</mat-label>
                        <input [type]="passwordType" appAutofill formControlName="password" matInput/>
                        <button (click)="showPassword()"
                                [matTooltip]="passwordType == 'password' ? 'Show password' : 'Hide password'"
                                class="h-fit-content p0" mat-icon-button
                                matSuffix
                                type="button">
                            @if (passwordType == 'password') {
                                <mat-icon color="accent">remove_red_eye
                                </mat-icon>
                            }
                            @if (passwordType == 'text') {
                                <mat-icon color="accent">highlight_off</mat-icon>
                            }
                        </button>
                        @if (loginForm.controls['password'].hasError('required')) {
                            <mat-error>
                                This field is required
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-checkbox color="accent" formControlName="keep_logged_in">
                        Remember me
                    </mat-checkbox>
                </form>
                <button (click)="needLogin = false" mat-button>
                    Back to registration
                </button>
                <div class="w-100 text-center">
                    <button (click)="login()"
                            [disabled]="loginForm.invalid || loading"
                            color="accent" mat-flat-button>
                        Login
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="accent"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                </div>
            } @else if (view == 'Code') {
                <div class="loginSection">
                    <h2>A code has been sent to {{ sentTo?.email }}</h2>
                    @if (community?.mfa_tab_text) {
                        <div class="flex-col flex-space-between mb-15">
                            @if (community?.mfa_tab_text_rendered) {
                                <div [innerHTML]="community?.mfa_tab_text_rendered"></div>
                            } @else {
                                {{ community?.mfa_tab_text }}
                            }
                        </div>
                    }
                    <form [formGroup]="otpForm">
                        <mat-form-field appearance="outline" class="w-100" color="primary">
                            <mat-label>Code</mat-label>
                            <input (keyup.enter)="finishLoginIfValid(otpForm.invalid)" formControlName="code"
                                   autocomplete="one-time-code"
                                   matInput type="text"/>
                            @if (otpForm.controls['code'].hasError('required')) {
                                <mat-error>
                                    This field is required
                                </mat-error>
                            }
                        </mat-form-field>
                    </form>
                    <small>
                        Codes may take 1-2 minutes to arrive, please wait at least 30 secs before requesting a
                        new one.
                    </small>
                </div>
                <button (click)="needLogin = false" mat-button>
                    Back to registration
                </button>
                <div class="text-center flex-row flex-space-around">
                    <div>
                        <button (click)="request2fa()" [disabled]="loading || timer > 0"
                                (keyup.enter)="request2fa()"
                                class="mx-auto my-10 mx-10"
                                color="accent" mat-flat-button type="button">
                            @if (timer) {
                                Code request available again in {{ timer }} seconds
                            }
                            @if (!timer) {
                                Re-Send Code
                            }
                        </button>
                    </div>
                    <button (click)="finishLogin()" (keyup.enter)="finishLogin()"
                            [disabled]="otpForm.invalid || loading"
                            class="mx-auto my-10 mx-10"
                            color="primary" mat-flat-button type="submit">
                        Continue
                        @if (loading) {
                            <mat-icon>
                                <mat-spinner color="primary"></mat-spinner>
                            </mat-icon>
                        }
                    </button>
                </div>
            }

        }
    </mat-step>
</mat-stepper>
